import { Link } from 'react-router-dom';

export const LegalFooter = ({ dark = false }) => {
  const year = new Date().getFullYear();
  const base = dark
    ? 'bg-charcoal border-t border-white/[0.06] text-white/40'
    : 'bg-gray-50 border-t border-gray-100 text-gray-400';
  const linkClass = dark
    ? 'hover:text-white transition-colors'
    : 'hover:text-gray-700 transition-colors';

  return (
    <footer className={`${base} py-8 px-6`} data-testid="legal-footer">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs">
            &copy; {year} ReadyToBuildIt.life. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs">
            <Link to="/about" className={linkClass} data-testid="footer-about">About</Link>
            <Link to="/terms" className={linkClass} data-testid="footer-terms">Terms of Service</Link>
            <Link to="/privacy" className={linkClass} data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/admin" className={linkClass} data-testid="footer-admin">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
